import { useEffect, useState } from "react";
import Error404 from "../../../../../../Error404";
import { lineupViewDataAPI } from "../../../../../../../services/api/projectCurrent";
import { useParams } from "react-router-dom";
import { formatLineUpData } from "../../../../../../../helpers/lineUpFormatter";



export default function LineupInfo(staff, others) {
    const [musicians, setMusicians] = useState({})
    const params = useParams()

    useEffect(() => {
        const get_DataAPI = async () => {
            const response = await lineupViewDataAPI(params.id)
            if (response.status === 200) {
                setMusicians(response.data)

            } else return <Error404/>
        }
        get_DataAPI()

    }, [params.id])

    const formatted = formatLineUpData(musicians);

    return (
    <>
        <div>{JSON.stringify(musicians, null, 2)}</div>

        {Object.entries(formatted.String).map(([instrument, lines]) => (
        <div key={instrument}>
            <h4>{instrument}</h4>
            {lines.map((line, i) => (
            <p key={i}>{line}</p>
            ))}
        </div>
        ))}

    </>)
}

